@import '~less/global-variables';

.media-list-divider {
  padding-top: @padding-large-horizontal;
  @media (min-width: @screen-sm-min) {
    width: 160px;
    text-align: right;
  }
}
dl.media-list {
  dt {
    font-weight: normal;
    white-space: normal;
    padding-top: @padding-large-horizontal;
    @media (min-width: @screen-sm-min) {
      padding-top: 0;
      padding-bottom: @padding-large-horizontal;
    }
  }
  dd {
  }
  h4 {
    margin-top: 5px;
    margin-bottom: 0;
  }
}
